import HomePayNow from "@/assets/images/3d-icons/home-paynow.png";
import { useAuthState } from "@/store/auth";
import { formatPrice } from "@/lib/helpers/number";
import type { TodoCardProps } from "../TodoCard";
import { useRoute } from "@/components/shared/router";

export const usePaymentOverdueCard = (): TodoCardProps | null => {
  const { push } = useRoute();
  const billingAccount = useAuthState(
    (state) => state.data.userInfo.billingAccount,
  );
  if (!billingAccount || billingAccount.totalOverdueInvoice === 0) return null;
  const count = billingAccount.totalOverdueInvoice;
  const total = formatPrice(billingAccount.overdueAmount);
  const handlePayNow = () => {
    push("/profile/invoices");
  };

  return {
    onClick: handlePayNow,
    image: HomePayNow,
    title: `Total ${total}`,
    desc: `${count} Payment Overdue`,
    titleColor: "danger",
  };
};
